<div
  class="loading-overlay"
  [class.full]="full"
  [class.general]="general"
  *ngIf="isLoading"
>
  <div class="loading">
    <span class="loader"><span class="loader-inner"></span></span>
  </div>
</div>
